/**
 * RoleSelector – Dropdown populated from GraphQL reference_user_role.
 */

import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';
import type { ReferenceUserRole } from '@/types/dashboardConfig';

interface RoleSelectorProps {
  roles: ReferenceUserRole[];
  isLoading: boolean;
  value: string; // role string e.g. "ES"
  onChange: (role: string, roleId: number) => void;
  disabled?: boolean;
}

export function RoleSelector({ roles, isLoading, value, onChange, disabled }: RoleSelectorProps) {
  const handleChange = (val: string) => {
    const found = roles.find((r) => r.role === val);
    if (found) onChange(found.role, found.role_id);
  };

  return (
    <div className="space-y-1.5">
      <Label className="text-sm font-medium text-foreground">User Role</Label>
      <Select value={value} onValueChange={handleChange} disabled={disabled || isLoading}>
        <SelectTrigger className="w-full">
          {isLoading ? (
            <span className="flex items-center gap-2 text-muted-foreground">
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
              Loading roles…
            </span>
          ) : (
            <SelectValue placeholder="Select Role" />
          )}
        </SelectTrigger>
        <SelectContent>
          {roles.map((r) => (
            <SelectItem key={r.role_id} value={r.role}>
              {r.role}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
